import React, { useState } from "react";
import { FaEnvelope, FaPhone } from "react-icons/fa";

const Contact = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // TODO: Call your API here
    console.log("Form submitted:", form);
    setForm({ name: "", email: "", subject: "", message: "" });
    alert("Message sent!");
  };

  return (
    <section id="contact" className="bg-gray-900 text-gray-300 py-16">
      <div className="max-w-6xl mx-auto px-6 md:px-12">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-2">
          Get In Touch
        </h2>
        <p className="text-center text-gray-400 mb-12">
          Ready to onboard your hotel? Let's discuss how we can help.
        </p>

        <div className="flex flex-col md:flex-row gap-12">
          {/* Contact Info */}
          <div className="flex-1 space-y-6">
            <div className="flex items-start space-x-4">
              <FaEnvelope size={24} className="text-blue-400 mt-1" />
              <div>
                <h4 className="font-semibold text-gray-100">Email</h4>
                <p>techadmin@hotel-hub.com</p>
              </div>
            </div>
            <div className="flex items-start space-x-4">
              <FaPhone size={24} className="text-blue-400 mt-1" />
              <div>
                <h4 className="font-semibold text-gray-100">Phone</h4>
                <p>+880 1234 567890</p>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <form
            onSubmit={handleSubmit}
            className="flex-1 space-y-4 bg-gray-800 p-6 md:p-8 rounded-xl shadow-lg"
          >
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              value={form.name}
              onChange={handleChange}
              className="w-full p-3 rounded-lg bg-gray-900 border border-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-400"
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Your Email"
              value={form.email}
              onChange={handleChange}
              className="w-full p-3 rounded-lg bg-gray-900 border border-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-400"
              required
            />
            <input
              type="text"
              name="subject"
              placeholder="Subject"
              value={form.subject}
              onChange={handleChange}
              className="w-full p-3 rounded-lg bg-gray-900 border border-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-400"
              required
            />
            <textarea
              name="message"
              placeholder="Your Message"
              rows={5}
              value={form.message}
              onChange={handleChange}
              className="w-full p-3 rounded-lg bg-gray-900 border border-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-400"
              required
            ></textarea>
            <button
              type="submit"
              className="w-full py-3 bg-blue-600 text-white font-bold rounded-full shadow-lg hover:bg-blue-700 transition-all duration-300"
            >
              Send Message
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
